// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '@/redux/http';
import endPoints from '@/redux/constant';

export const sendMailToBrand = createAsyncThunk(
    'collabRating/sendMailToBrand',
    async ({ resUrl, collabrationRating }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.sendMailToBrand}?url=${resUrl}&collabrationRating=${collabrationRating}`;
            const response = await axiosInstance.post(url);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to send mail.');
        }
    }
);

export const sendOtpMail = createAsyncThunk(
    'collabRating/sendOtpMail',
    async ({ brandEmail, creatorId, brandContactPersonName }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.sendOtpMail}?brandEmail=${brandEmail}&creatorId=${creatorId}&brandConractPersonName=${brandContactPersonName}`;
            const response = await axiosInstance.post(url);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to send OTP mail.');
        }
    }
);

export const verifyOTPMail = createAsyncThunk(
    'collabRating/verifyOTPMail',
    async ({ brandEmail, creatorId, otpVal }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.verifyOTPMail}?brandEmail=${brandEmail}&creatorId=${creatorId}&otp=${otpVal}`;
            const response = await axiosInstance.get(url);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data);
        }
    }
);

export const submitMediaKitReview = createAsyncThunk(
    'collabRating/submitMediaKitReview',
    async ({ data, callingUserId }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.submitMediaKitReview}?callingUserId=${callingUserId}`;
            const response = await axiosInstance.post(url, data);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.responseException || error?.response?.data?.message || error?.response?.data || 'Failed to submit review');
        }
    }
);

export const triggerMail = createAsyncThunk(
    'collabRating/triggerMail',
    async (data, { rejectWithValue }) => {
        try {
            const url = endPoints.triggerMail;
            const response = await axiosInstance.post(url, data);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to trigger mail.');
        }
    }
);

export const getCreatorDetailsApi = createAsyncThunk(
    'collabRating/getCreatorDetailsApi',
    async ({ reqId, callingUserId }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.getCreatorDetailsApi}?callingUserId=${callingUserId}&requestReviewId=${reqId}`;
            const response = await axiosInstance.get(url);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to get creator details.');
        }
    }
);

export const getCreatorRequestReviewById = createAsyncThunk(
    'collabRating/getCreatorRequestReviewById',
    async ({ reqId, callingUserId }, { rejectWithValue }) => {
        try {
            const url = `${endPoints.getCreatorRequestReviewById}/${reqId}?callingUserId=${callingUserId}`;
            const response = await axiosInstance.get(url);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to get creator request review.');
        }
    }
);

export const sendMailOtpToBrand = createAsyncThunk(
    'collabRating/sendMailOtpToBrand',
    async ({ brandEmail, creatorId, brandContactPersonName }, { dispatch, rejectWithValue }) => {
        try {
            await dispatch(sendOtpMail({ brandEmail, creatorId, brandContactPersonName }));
            await dispatch(triggerMail({}));
            return { message: 'Email sent successfully.' };
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.response?.data || 'Failed to send OTP mail.');
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    data: null,
};

const collabRatingSlice = createSlice({
    name: 'collabRating',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendMailToBrand.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendMailToBrand.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(sendMailToBrand.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(sendOtpMail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendOtpMail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(sendOtpMail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(verifyOTPMail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(verifyOTPMail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(verifyOTPMail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(submitMediaKitReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(submitMediaKitReview.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(submitMediaKitReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(triggerMail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(triggerMail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(triggerMail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getCreatorDetailsApi.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCreatorDetailsApi.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getCreatorDetailsApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getCreatorRequestReviewById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCreatorRequestReviewById.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getCreatorRequestReviewById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(sendMailOtpToBrand.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendMailOtpToBrand.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(sendMailOtpToBrand.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default collabRatingSlice.reducer;

